import script from "./diamondsSearchFormIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormIcons.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormIcons.vue?vue&type=style&index=0&id=5d0f9886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0f9886"]])

export default __exports__